<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> {{ title }}</strong>
          </div>
          <b-form>
            <b-form-group label="Liste des SIREN" label-for="siren">
              <b-form-textarea
                id="siren"
                type="text"
                :class="{hasError: errors.siren !== ''}"
                rows="2"
                placeholder="Vous pouvez saisir plusieurs siren séparés par des ;"
                v-model="siren">
              </b-form-textarea>
              <span class="field-error">{{ errors.siren }}</span>
              Saisissez les SIREN et/ou sélectionnez un groupe de SIREN pour ajouter les SIREN de ce groupe.
              <b-form-select v-model="groupeSirenSelected" :options="groupeSirenOptions" @change="manageSiren">
                <b-form-select-option :value="null">Groupe SIREN</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group label='Date début' label-for='date_debut'>
              <b-form-input id='date_debut' type='date'
                          :class="{hasError: errors.date_debut !== ''}"
                          v-model="date_debut">
              </b-form-input>
              <span class='field-error'>{{ errors.date_debut }}</span>
            </b-form-group>
            <b-form-group label='Date fin' label-for='date_fin'>
              <b-form-input id='date_fin' type='date'
                          :class="{hasError: errors.date_fin !== ''}"
                          v-model="date_fin">
              </b-form-input>
              <span class='field-error'>{{ errors.date_fin }}</span>
            </b-form-group>
            <b-form-group
              label-for='nom_fichier1'>
              <template slot="label"><b>Pièces Jointes</b></template>
              <b-form-file placeholder="Veuillez choisir ou déposer le(s) fichier(s) ici"
                class="file-input"
                drop-placeholder="Déposer le(s) fichier(s) ici..."
                browse-text="Parcourir"
                :state="errors.consigneAttachments !== '' ? false : null"
                @change="addFileToConsigne($event)"
                multiple
                :disabled="isDisabled()">
              </b-form-file>
              <b-row>
                <b-col sm="9"></b-col>
                <b-col sm="3" style="text-align:right">
                  Le nombre de pièces jointes est limité à : {{ maxPjConsigne }}
                </b-col>
              </b-row>
              <span class="field-error">{{ errors.consigneAttachments }}</span>
              <div v-if="pieceJointes">
                <li v-for="pj in pieceJointes" :key="pj.id" style="list-style:none">
                  <a :id="`pj_${pj.id}`" href="#" @click.prevent="download(pj.id, pj.nom_fichier)" style="font-size:12px;color:#831491"><i class="fa fa-tag"></i> {{ pj.nom_fichier }}
                  ({{ formatBytes(pj.taille) }})</a>
                  <i class="fa fa-trash" v-if="canDelete(pj)" @click="deletePj(pj.id)" title="Supprimer pièce jointe" style="cursor:pointer;color:#cd0303;margin-left:6px"></i>
                </li>
              </div>
            </b-form-group>
            <b-form-group label="Commentaire" label-for="commentaire">
              <b-form-textarea
                id="commentaire"
                type="text"
                :class="{hasError: errors.commentaire !== ''}"
                rows="4"
                v-model="commentaire">
              </b-form-textarea>
              <span class="field-error">{{ errors.commentaire }}</span>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des consignes
              </b-button>
              <b-button type="button" @click="edit('stay')" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
              <b-button type="button" @click="edit('quit')" size="md" class="pull-right mr-2" variant="warning">
                <i class="fa fa-save"/> Enregistrer et Quitter
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {downloadFile, guardedFile, isEmpty} from "@/utils/fileHelper"
  import {MAX_PJ_CONSIGNE} from '@/utils/constants'

  export default {
    name: "Edit",
    data() {
      return {
        id: null,
        siren: '',
        date_debut: '',
        date_fin: '',
        commentaire: '',
        title: '',
        consigneAttachments: null,
        errors: {
          commentaire: '',
          siren: '',
          date_debut: "",
          date_fin: "",
          consigneAttachments: '',
        },
        maxPjConsigne: MAX_PJ_CONSIGNE,
        pieceJointes: null,
        groupeSirenOptions: [],
        groupeSirenSelected: null,
        allGroupeSiren: [],
      }
    },
    mounted() {
      this.getGroupSiren();

      if (!isEmpty(this.$route.query.id)) {
        this.id = this.$route.query.id;
        this.getConsigneSiren();
        this.title = 'Modification de la consigne';
      } else {
        this.title = 'Création d\'une nouvelle consigne SIREN';
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      getConsigneSiren() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/consignes-siren/' + this.id)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            // this.siren = response.data.consigne.siren;
            // this.commentaire = response.data.consigne.commentaire;
            // this.date_debut = response.data.consigne.date_debut;
            // this.date_fin = response.data.consigne.date_fin;
            // this.pieceJointes = response.data.consigne.consigne_attachments;
            this.setForm(response.data.consigne);
          })
          .catch((error) => {
            console.log(error)
            self.handleError(self);
          });
      },
      getGroupSiren() {
        let self = this;
        this.$axios
          .get('/espaceQualite/groupes-siren-complet')
          .then(response => {
            this.allGroupeSiren = response.data.groupes_siren;
            for (let group of response.data.groupes_siren) {
              this.groupeSirenOptions.push({value: group.id, text: group.libelle})
            }
            // this.commentaire = response.data.consigne.commentaire;
            // this.date_debut = response.data.consigne.date_debut;
            // this.date_fin = response.data.consigne.date_fin;
            // this.pieceJointes = response.data.consigne.consigne_attachments;
          })
          .catch((error) => {
            console.log(error)
            self.handleError(self);
          });
      },
      setForm(consigneSiren) {
        this.siren = consigneSiren.siren;
        this.date_debut = consigneSiren.date_debut;
        this.date_fin = consigneSiren.date_fin;
        this.commentaire = consigneSiren.commentaire;
        this.pieceJointes = consigneSiren.consigne_attachments;
      },
      addFileToConsigne(event) {
        this.consigneAttachments = event.target.files;
      },
      edit(type) {
        if (this.validateData()) {
          let self = this;
          let formData = new FormData();
          if (this.consigneAttachments) {
            for( var i = 0; i < this.consigneAttachments.length; i++ ){
              let file = this.consigneAttachments[i];
              formData.append('files[' + i + ']', file);
            }
          }
          formData.append('siren', this.siren);
          formData.append('date_debut', this.date_debut);
          formData.append('date_fin', this.date_fin);
          formData.append('commentaire', this.commentaire);
          formData.append('consigneId', this.id);
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post('/espaceGestion/consignes-siren', formData)
            .then((response) => {
              this.$store.commit('IS_LOADING', false);
              let title = isEmpty(this.id) ? 'Création avec succès' : 'Modification avec succès';
              let text = isEmpty(this.id) ? 'La consigne a bien été créée.' : 'La consigne a bien été modifiée.';
              this.$swal({
                position: 'top',
                type: 'success',
                title: title,
                text: text,
                showConfirmButton: false,
                timer: 5000
              });
              if (type === 'quit') {
                this.returnBack()
              } else {
                this.$router.push({path: '/espace-gestion/consignes-siren/edit/', query: {id: response.data.consigne.id}})
                window.location.reload();
              }
            })
            .catch((error) => {
              console.log(error)
              self.handleError(self);
            });
        }
      },
      returnBack() {
        this.$router.push({path: '/espace-gestion/consignes-siren/list'});
      },
      validateData() {
        this.clearErrors()
        let dateFrom = new Date(this.date_debut)
        let dateTo = new Date(this.date_fin)
        let valid = true;

        if (isEmpty(this.siren)) {
          this.errors.siren = 'Vous devez renseigner au moins un SIREN';
          valid = false;
        }

        if (this.pieceJointes && this.consigneAttachments) {
          let totalFileLength = this.pieceJointes.length + this.consigneAttachments.length
          if (totalFileLength > this.maxPjConsigne) {
            this.errors.consigneAttachments = "Le nombre de pièces jointes est limité à : " + this.maxPjConsigne
            valid = false
          }
        }

        if (isEmpty(this.commentaire)) {
          this.errors.commentaire = 'Vous devez saisir une consigne';
          valid = false;
        }

        if (!this.date_debut) {
            this.errors.date_debut = "La date de début est obligatoire"
            valid= false;
        }
        if (!this.date_fin) {
            this.errors.date_fin = "La date de fin est obligatoire"
            valid= false;
        }
        if (this.date_fin !== null && this.date_fin !== "") {
          if (dateTo.getTime() < dateFrom.getTime()) {
            this.errors.date_fin = "La date de fin doit être postérieure à la date de début"
            valid= false;
          }
        }

        return valid;
      },
      clearErrors() {
        this.errors.siren = '';
        this.errors.commentaire = '';
        this.errors.consigneAttachments = "";
        this.errors.date_fin = "";
      },
      handleError(self) {
        self.$store.commit('IS_LOADING', false);
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support Dosi.',
          showConfirmButton: false,
          timer: 5000
        });
      },
      download(id, filename) {
        let fileNameArr = filename.trim().split('.');
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');
        let link = document.getElementById('pj_'+id);
        link.style.color = 'violet';
        if(this.canDownloadGuardedFile(ext)) {
          this.$axios
            .get("/espaceGestion/consignes/piece-jointe/download/"+id, {responseType: 'blob'})
            .then(response => {
              downloadFile(response, name, ext);
            })
            .catch(() => {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 4000
              });
            })
        } else {
          this.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Vous n'avez pas le droit pour télécharger cette pièce jointe",
            showConfirmButton: false,
            timer: 3500
          });
        }
      },
      formatBytes(bytes, precision = 2) {
        let units = ['o', 'Ko', 'Mo', 'Go', 'To']

        let varBytes = Math.max(bytes, 0);
        let pow = Math.floor((bytes ? Math.log(bytes) : 0) / Math.log(1024))
        pow = Math.min(pow, units.length - 1)

        varBytes /= Math.pow(1024, pow)

        return Math.round(varBytes, precision) + ' ' + units[pow]
      },
      canDownloadGuardedFile(extension) {
        let valid = true;
        if(_.includes(guardedFile, extension)) {
          valid = hasRule(rules.CAN_DOWNLOAD_GUARDED_FILE);
        }
        return valid;
      },
      canDelete(pj) {
        return true
      },
      deletePj(pjId) {
        let self = this
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer ce fichier ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .post("/espaceGestion/consignes/piece-jointe/delete/" + pjId)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le fichier a bien été supprimé',showConfirmButton: false, timer: 3000})
                let pjToRemove = _.filter(this.pieceJointes, (pj) => pj.id === pjId)
                let pjIndex = this.pieceJointes.indexOf(pjToRemove)
                this.pieceJointes.splice(pjIndex, 1)
                this.getConsigneSiren()
              })
              .catch(function(error){
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      isDisabled() {
        return (this.pieceJointes && this.pieceJointes.length >= this.maxPjConsigne) ? true : false
      },
      manageSiren() {
        let groupeSiren = this.allGroupeSiren.find(group => group.id === this.groupeSirenSelected);
        let sirensSaisie = this.siren.replaceAll(',',';');
        let sirenArray = sirensSaisie.split(';')
        for (let siren of groupeSiren.sirens) {
          sirenArray.push(siren.siren);
        }
        sirenArray = [...new Set(sirenArray)];

        this.siren = sirenArray.join(';').replace(/^;/g, '');
      },
    }
  }
</script>
